import React from 'react';
import { QuickServiceTileSection } from './QuickServiceTileSection';
import { buildOrderedQuickTiles, type CmsTopicSections } from '../utils/resolveQuickSection';

const TILE_ORDER = ['traffic-ticket', 'legal-consult', 'fraud-disputes', 'immigration'] as const;

const TILE_ICONS: Record<string, string> = {
  'traffic-ticket': 'ti-ticket',
  'legal-consult': 'ti-phone-call',
  'fraud-disputes': 'ti-gavel',
  immigration: 'ti-plane-departure',
};

export interface LegalImmigrationQuickSectionProps {
  onSelect: (categoryId: string, slug: string) => void;
  topicSections: CmsTopicSections;
}

export const LegalImmigrationQuickSection: React.FC<LegalImmigrationQuickSectionProps> = ({
  onSelect,
  topicSections,
}) => (
  <QuickServiceTileSection
    id="legal"
    title="Legal & Immigration Assistance"
    items={buildOrderedQuickTiles('legal', TILE_ORDER, TILE_ICONS, topicSections, 'ti-scale')}
    onSelect={onSelect}
  />
);
